import { ContactObjectSchema as OriginalContactObjectSchema } from '../processed/contact-object'

/**
 * Contact Object
 *
 * Contact information for the exposed API.
 *
 * @see https://github.com/OAI/OpenAPI-Specification/blob/main/versions/3.1.1.md#contact-object
 */
export const ContactObjectSchema = OriginalContactObjectSchema
